<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="散点样式" name="1">
        <cx-select title="散点形状" :selectOptions="symbolType" :value.sync="symbol" />
        <div class="verticallyCenter mt16">
          <span class="mr16">散点尺寸</span>
          <div class="verticallyCenter mr12 flex1">
            <single-input
              style="width: 100%"
              :value.sync="symbolSizeWidth"
              inputSuffixs="宽"
            />
<!--            <el-input type="number" v-model="symbolSizeWidth" style="width: 100%">-->
<!--              <template slot="suffix">-->
<!--                <span class="suffix_text">宽</span>-->
<!--              </template>-->
<!--            </el-input>-->
          </div>
          <div class="verticallyCenter flex1">
            <single-input
              style="width: 100%"
              :value.sync="symbolSizeHeight"
              inputSuffixs="高"
            />
<!--            <el-input type="number" v-model="symbolSizeHeight" style="width: 100%">-->
<!--              <template slot="suffix">-->
<!--                <span class="suffix_text">高</span>-->
<!--              </template>-->
<!--            </el-input>-->
          </div>
        </div>
        <!-- <slider-and-input
          class="mt16"
          :value.sync="sizeWidth"
          titlePosition="singleLine"
          title="散点尺寸"
          :showSlider="false"
          suffix="px"
        />
        <slider-and-input :value.sync="sizeHeight" titlePosition="singleLine" :showSlider="false" suffix="px" /> -->
        <color-picker class="mt16" title="填充颜色" :color.sync="roundColor"></color-picker>
        <color-picker class="mt16" title="边框颜色" :color.sync="lineColor"></color-picker>
        <p class="mt16">边框宽度</p>
        <slider-and-input
          :value.sync="scatterBorderWidth"
          titlePosition="singleLine"
          :sliderMax="100"
          suffix="px"
        />
        <p class="mt16">动画时间</p>
        <slider-and-input
          :value.sync="period"
          titlePosition="singleLine"
          :sliderMax="20"
          suffix="秒"
        />
      </el-collapse-item>
      <el-collapse-item title="标签" name="2">
        <div>
          <cx-check-box :value.sync="showScatterText">显示标签文字</cx-check-box>
          <div v-show="showScatterText">
            <cx-select title="显示位置" :selectOptions="positionType" :value.sync="labelPosition" class="mt16"/>
            <p class="mt16">文字样式</p>
            <text-setting-update
              class="mt8"
              :fontColor.sync="labelFontColor"
              :fontFamily.sync="labelFontFamily"
              :fontSize.sync="labelFontSize"
              :fontWeight.sync="labelFontWeight"
            />
            <!-- <slider-and-input
              class="mt16"
              :value.sync="labelOffsetX"
              title="横轴偏移"
              :sliderMin="-100"
              :sliderMax="100"
              suffix="px"
            />
            <slider-and-input
              class="mt16"
              :value.sync="labelOffsetY"
              title="纵轴偏移"
              :sliderMin="-100"
              :sliderMax="100"
              suffix="px"
            /> -->
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="提示框" name="3">
        <div>
          <tooltipSetting :options="options" :show-auto-play-setting="false" />
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import tooltipSetting from "../../../map/toolbars/mapSettings/tooltipSetting"
export default {
  components: {
    tooltipSetting
  },
  data() {
    return {
      activeNames: ["1", "2", "3"],
      collapseActiveNames: ["1"],
      symbolType: [
        { label: "圆形", value: "circle" },
        { label: "矩形", value: "rect" },
        { label: "圆角矩形", value: "roundRect" },
        { label: "三角形", value: "triangle" },
        { label: "菱形", value: "diamond" },
        { label: "气球", value: "pin" },
        { label: "箭头", value: "arrow" }
      ],
      positionType: [{
        label: '上侧',
        value: 'top'
      }, {
        label: '下侧',
        value: 'bottom'
      }, {
        label: '左侧',
        value: 'left'
      }, {
        label: '右侧',
        value: 'right'
      }]
    }
  },
  props: {
    options: Object
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    chartOption() {
      return this.options.chartOption
    },
    symbolSizeWidth: {
      get() {
        return this.chartOption.scatter.symbolSize[0]
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.symbolSize.0", false)
      }
    },
    symbolSizeHeight: {
      get() {
        return this.chartOption.scatter.symbolSize[1]
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.symbolSize.1", false)
      }
    },
    roundColor: {
      get() {
        return this.chartOption.scatter.itemStyle.color
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.itemStyle.color", false)
      }
    },
    lineColor: {
      get() {
        return this.chartOption.scatter.itemStyle.borderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.itemStyle.borderColor", false)
      }
    },
    scatterBorderWidth: {
      get() {
        return this.chartOption.scatter.itemStyle.borderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.itemStyle.borderWidth", false)
      }
    },
    showScatterText: {
      get() {
        return this.chartOption.scatter.label.show
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.show", false)
      }
    },
    labelFontColor: {
      get() {
        return this.chartOption.scatter.label.labelFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.labelFontColor", false)
      }
    },
    labelFontFamily: {
      get() {
        return this.chartOption.scatter.label.labelFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.labelFontFamily", false)
      }
    },
    labelFontSize: {
      get() {
        return this.chartOption.scatter.label.labelFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.labelFontSize", false)
      }
    },
    labelFontWeight: {
      get() {
        return this.chartOption.scatter.label.labelFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.labelFontWeight", false)
      }
    },
    labelOffsetX: {
      get() {
        return this.chartOption.scatter.label.offset[0]
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.offset.0", false)
      }
    },
    labelOffsetY: {
      get() {
        return this.chartOption.scatter.label.offset[1]
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.offset.1", false)
      }
    },
    symbol: {
      get() {
        return this.chartOption.scatter.symbol
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.symbol", false)
      }
    },
    labelPosition: {
      get() {
        return this.chartOption.scatter.label.position
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.position", false)
      }
    },
    period: {
      get() {
        return this.chartOption.scatter.animationDurationUpdate / 1000
      },
      set(val) {
        this.$changeOptionsEV(val * 1000, "chartOption.scatter.animationDurationUpdate", false)
      }
    }
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    }
  }
}
</script>

<style scoped>
.top_span {
  margin-right: 16px;
}
</style>
